import { Component } from '@angular/core';
import { SIGNAL_PILLS } from '../../data/landing-content';

@Component({
  selector: 'app-signals-section',
  standalone: true,
  template: `
    <section class="signals-section landing-section compact">
      <p class="signals-intro reveal">KΛI notices. The path adjusts.</p>
      <div class="ticker-wrap reveal">
        <div class="ticker">
          @for (pill of pills; track pill.before) {
            <span class="signal-pill">
              <span class="sig-dot"></span>{{ pill.before
              }}<em>{{ pill.emphasis }}</em>
            </span>
          }
          @for (pill of pills; track pill.before + '-dup') {
            <span class="signal-pill">
              <span class="sig-dot"></span>{{ pill.before
              }}<em>{{ pill.emphasis }}</em>
            </span>
          }
        </div>
      </div>
    </section>
  `,
  styleUrl: './signals-section.component.scss',
})
export class SignalsSectionComponent {
  readonly pills = SIGNAL_PILLS;
}
